/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateMasterProduct } from './updateMasterProduct';
import { updateListing } from './updateListing';

export const changeProductCustomField = createAsyncThunk(
  'products/changeProductCustomField',
  async ({
    productId,
    layer,
    listingId,
    channelId,
    title,
    value,
  }, { dispatch }) => {
    const meta = { [title]: value };

    if (layer === 'master') {
      await dispatch(updateMasterProduct({ productId, data: { meta } })).unwrap();
      return {
        productId, layer, title, value, meta,
      };
    }

    if (layer === 'listing') {
      await dispatch(updateListing({
        listingId,
        masterProductId: productId,
        channelId,
        data: { meta },
      })).unwrap();
      return {
        productId, layer, listingId, channelId, title, value, meta,
      };
    }

    throw new Error(`Unsupported custom field layer: ${layer}`);
  },
);

export const reducer = (builder) => {
  builder
    .addCase(changeProductCustomField.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(changeProductCustomField.fulfilled, (state) => {
      state.isBusy = false;
    })
    .addCase(changeProductCustomField.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot update product custom field';
    });
};
